import { render, staticRenderFns } from "./transferFreeze.vue?vue&type=template&id=483afecb&"
import script from "./transferFreeze.vue?vue&type=script&lang=js&"
export * from "./transferFreeze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports